import { Component, Inject, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ExcelService } from 'src/app/core/api/services';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { BaseDownloadExcelPageComponent } from 'src/app/pages/shared/base/components/base-download-excel-page.component';

@Component({
    selector: 'app-create-smart-sms-request-excel-dialog',
    templateUrl: './create-smart-sms-request-excel-dialog.component.html',
    styles: [``],
    standalone: false
})
export class CreateSmartSmsRequestExcelDialogComponent
  extends BaseDownloadExcelPageComponent
  implements OnInit
{
  //#region properties
  dynamicTabService = inject(DynamicTabService);
  startDateTime;
  endDateTime;
  //#endregion

  constructor(
    protected currentService: ExcelService,
    protected dialogRef: MatDialogRef<CreateSmartSmsRequestExcelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.comparisonObjects = data?.comparisonObjects;
    this.sortObject = data?.sortObject;
  }
  //#region Api

  getExcel() {
    this.unSubs();
    this.loading = true;

    if (this.endDateTime != undefined && this.startDateTime != undefined) {
      this.endDateTime = DateTimeService.toUTC(this.endDateTime);
      this.startDateTime = DateTimeService.toUTC(this.startDateTime);
      if (this.startDateTime == this.endDateTime) {
        this.endDateTime = this.endDateTime?.split('T')[0];
        this.endDateTime = this.endDateTime + 'T23:59:59';
      }
    }

    this.currentService
      .excelCreateSmartSmsRequestsExcelPost({
        body: {
          title: this.title,
          comparisonObjects: this.comparisonObjects,
          orders: this.sortObject,
          endDateTime: this.endDateTime,
          startDateTime: this.startDateTime,
        },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDownloadExcelObserver);
  }

  //#endregion
}
